/** Public (SPA-side) configuration. Values are baked into the bundle at build time. */
export const env = {
  tenantId: (import.meta.env.VITE_ENTRA_TENANT_ID as string) ?? '',
  clientId: (import.meta.env.VITE_ENTRA_CLIENT_ID as string) ?? '',
  apiScope: (import.meta.env.VITE_API_SCOPE as string) ?? '',
  adoOrg: (import.meta.env.VITE_ADO_ORG as string) || 'endpointas',
};
